import Api from '@/Api'

export default class FileDownloaderApi extends Api {
  constructor(options = {}) {
    super(options)
    this.fileName = options.fileName
  }

  /**
   * OVERRIDE Api._makeRequest because we don't want to call response.json() here.
   * Instead, make the call to directly download the file to the browser.
   * Wraps `fetch` method and runs additional necessary logic for requests
   * @param {String} url - resource location
   * @param {Object} requestOptions - fetch configuration
   * @returns {Promise} a promise resolving to the response body
   * @private
   */
  _makeRequest = (url, requestOptions = {}) => {
    return fetch(url, requestOptions)
      .then(response => this._verifyStatus(response))
      .then(response => this._handleContentTypes(response))
  };

  /**
   * Given a response with a valid content-type, creates a file and forces a download in the browser
   * OR (and this branching should be removed in future iterations) it can deserialize the response body.
   * @param {Response} response
   * @returns {Response}
   * @private
   */
  _handleContentTypes = (response) => {
    let contentType = response.headers.get('Content-Type')

    /* Append content-type strings to this array to support different file types */
    let fileDownloadContentTypes = [
      'text/csv',
      'application/force-download',
      'text/csv;charset=UTF-8'
    ]

    if (fileDownloadContentTypes.includes(contentType)) { return this._downloadFile(response) } else { return response.json() }
  }

  /**
   * Given a response with a valid content-type, creates a file and forces a download in the browser
   * @param {Response} response
   * @returns {Response}
   * @private
   */
  _downloadFile = (response) => {
    let clonedResponse = response.clone()
    return clonedResponse.blob()
      .then(blob => {
        let url = window.URL.createObjectURL(blob)
        let linkToDownload = document.createElement('a')
        linkToDownload.href = url
        linkToDownload.download = this.fileName
        document.body.appendChild(linkToDownload)
        linkToDownload.click()
        linkToDownload.remove()
      })
  };
}
